/**
 * The world is metres, because that is what every physics number in the game
 * wants to be: 4 m/s is a legible sprint, 9.81 is gravity, and a 0.35m capsule
 * radius is a person.
 *
 * The *building* is feet, because that is what a building is. Door heights,
 * ceiling heights and banquet table spacing are all specified in feet by the
 * people who actually build ballrooms, and a blockout authored in metres would
 * be a blockout authored in guesses.
 *
 * So level data is written in feet and converted here, once. Nothing downstream
 * of `src/world/` ever sees a foot.
 */

/** Metres in one foot. */
export const FOOT = 0.3048;

/** Feet to metres. */
export const ft = (feet) => feet * FOOT;

/** Inches to metres. */
export const inch = (inches) => (inches * FOOT) / 12;

/** Metres back to feet, for anything that has to be reported to a human. */
export const toFeet = (metres) => metres / FOOT;

/** The blockout's fixed dimensions, so nothing has to re-guess them. */
export const SPEC = Object.freeze({
  /** Back of house door opening: 3ft wide, 7ft tall. */
  doorWidth: ft(3),
  doorHeight: ft(7),
  /** A double door out to the ballroom. */
  doubleDoorWidth: ft(6),
  /** Concrete corridor ceiling. */
  bohCeiling: ft(9),
  /** Wall thickness, drawn. Collision uses the same boxes. */
  wallThickness: ft(0.5),
});
